export const initialState = {
    Ref : [],
    btn : null
};

const reducer = (state, action) => {
    switch(action.type) {
        case "ADD_REF":
            return {
                ...state,
                Ref : [...state.Ref, action.ref - 56]
            };
        case "BTN" :
            return {
            ...state,
            btn : action.btn
        };
        default :
            return state;
    }
};

export default reducer;